import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";

const UpdatePassword = () => {
  const [formData, setFormData] = useState({
    uid: 10,
    oldpassword: "",
    password: "",
    cpassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can add validation to check if the new password and confirm password match
    if (formData.password !== formData.cpassword) {
      alert("New passwords do not match!");
      return;
    }
    // Handle form submission (e.g., send data to an API)
    console.log("Changing password for UID:", formData.uid);
    console.log("Old Password:", formData.oldpassword);
    console.log("New Password:", formData.password);
    // Reset the form if needed
    setFormData({
      uid: 10,
      oldpassword: "",
      password: "",
      cpassword: "",
    });
  };

  return (
    <DashboardLayout>
      <form onSubmit={handleSubmit} className="mx-4">
        <input type="hidden" name="uid" value={formData.uid} />
        <h2 className="my-4">Change Your Password</h2>

        <div className="row form-group">
          <div className="col-md-5">
            <strong>Old Password:</strong>
            <br />
          </div>
          <div className="col-md-5">
            <input
              type="password"
              name="oldpassword"
              id="oldpassword"
              className="form-control"
              required
              value={formData.oldpassword}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-md-5">
            <strong>New Password:</strong>
            <br />
          </div>
          <div className="col-md-5">
            <input
              type="password"
              name="password"
              id="password"
              className="required form-control"
              required
              pattern=".{6,100}"
              title="6 characters minimum"
              value={formData.password}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-md-5">
            <strong>Repeat New Password:</strong>
            <br />
          </div>
          <div className="col-md-5">
            <input
              type="password"
              name="cpassword"
              id="cpassword"
              className="required form-control"
              required
              value={formData.cpassword}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-lg-3">
            <input
              type="submit"
              value="Change Password"
              className="btn site_btn text-white"
            />
          </div>
        </div>
      </form>
    </DashboardLayout>
  );
};

export default UpdatePassword;
